import { render, staticRenderFns } from "./ShareContent.vue?vue&type=template&id=0973cc24"
import script from "./ShareContent.vue?vue&type=script&lang=js"
export * from "./ShareContent.vue?vue&type=script&lang=js"
import style0 from "./ShareContent.vue?vue&type=style&index=0&lang=postcss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports